var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3952 15.9761C19.852 12.8209 19.63 8.25612 16.7295 5.3556C13.5887 2.2148 8.49642 2.2148 5.35561 5.3556C2.2148 8.49642 2.2148 13.5887 5.35561 16.7295C8.25614 19.63 12.821 19.8519 15.9762 17.3952C15.9897 17.4106 16.0039 17.4257 16.0186 17.4403L20.2838 21.7055C20.6764 22.0982 21.313 22.0982 21.7056 21.7055C22.0981 21.3129 22.0981 20.6764 21.7056 20.2838L17.4404 16.0186C17.4256 16.0039 17.4105 15.9898 17.3952 15.9761ZM15.2426 6.75737C17.5858 9.10051 17.5858 12.8995 15.2426 15.2427C12.8995 17.5858 9.1005 17.5858 6.75736 15.2427C4.41421 12.8995 4.41421 9.10051 6.75736 6.75737C9.1005 4.41421 12.8995 4.41421 15.2426 6.75737Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.820987901ee247129dcc1ee782808369.svg";
export { ForwardRef as ReactComponent };